import ComorbiditiesMenu from "./ClinicalMenuItems/ComorbiditesMenu";
import SymptomsMenu from "./ClinicalMenuItems/SypmtomsMenu";
interface ClinicalMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}
const ClinicalMenu: React.FC<ClinicalMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  return (
    <>
      <div className="collapse collapse-plus  rounded-sm w-full">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">
            Baseline Comorbidities{" "}
          </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <ComorbiditiesMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></ComorbiditiesMenu>
          </p>
        </div>
      </div>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">Symptoms </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <SymptomsMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></SymptomsMenu>
          </p>
        </div>
      </div>
    </>
  );
};

export default ClinicalMenu;
